import { ApplicationElement, html } from '../application_element/element.js';
import { classMap } from 'lit/directives/class-map.js';

import translations from './translations.js';
import style from './style.lit.css';

import ChatMessageBase from '../chat_message_base/element.js';

/**
 * In messages that reply to other messages, this element shows the original message
 *
 */

export default class ChatMessageReply extends ChatMessageBase {
  static styles = [ApplicationElement.styles, style];

  /** @internal */
  static translations = translations;

  render() {
    return html`
      <div class="sender">${this.my ? this.t('you') : this.userName}</div>

      <div class=${classMap(this.classes)}>
        ${this.errors && this.renderMessageError()} ${this.renderAttachment()}
        ${this.bodyOn ? this.renderMessageBody(150, 150) : null}
      </div>
    `;
  }
}

ChatMessageReply.registerTagName('ef-chat-message-reply');

customElements.get('ef-chat-message-reply') ||
  customElements.define('ef-chat-message-reply', ChatMessageReply);
